export default {
  params: {
    branchOffice_id: null,
    brand: null,
    list: null,
    product: null,
    line_id: null,
    option: 1,
    per_page: 50,
    page: 1
  },
  paramsUpdatePrices: [],
  branchOffices: [],
  brands: [],
  list: [],
  prices: {data:[]},
  lines: [],
  msgErrorLoadExcel: "",
  auditPriceList: [],
  pricesExcel: [],
  optionsSelect: [
    {
      value: 1,
      label: "1-Todos"
    },
    {
      value: 2,
      label: "2-Con Precio"
    },
  ]
};



// WEBPACK FOOTER //
// ./src/modules/prices/state.js